import { env } from '../../../../../common/util'

const resultExplainerPresetName = { dev: 'result_explainer', staging: 'result_explainer', prod: 'result_explainer' }

export const RESULT_EXPLAINER_PRESET_NAME = resultExplainerPresetName[env]
